import { createRouter, createWebHistory } from 'vue-router'

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL), // base should be here
    routes: [
        {
            path: "/",
            name: 'CreateScenario',
            component: () => import('@/components/CreateScenario.vue'), // Ensure the extension is included
        },
        {
            path: '/scenario-details/:scenarioUid',
            name: 'ScenarioDetails',
            component: () => import('@/components/ScenarioDetails.vue'), // Ensure the extension is included
        },
        {
            path: '/clone-scenario-details/:scenarioUid',
            name: 'CloneScenarioDetails',
            component: () => import('@/components/CloneScenarioDetails.vue'), // Ensure the extension is included
        },
        {
            path: '/view-scenario-details/:scenarioUid',
            name: 'ViewScenarioDetails',
            component: () => import('@/components/ViewScenarioDetails.vue'), // Ensure the extension is included
        },
        {
            path: "/report/:scenarioUid",
            name: 'ReportScenarioDetails',
            component: () => import('@/components/ReportScenarioDetails.vue'), // Ensure the extension is included
        },
        {
            path: '/summary-scenario-details/:scenarioUid',
            name: 'SummaryScenarioDetails',
            component: () => import('@/components/SummaryScenarioDetails.vue'), // Ensure the extension is included
        },
        {
            path: "/sep",
            name: 'SepDashBoard',
            component: () => import('@/components/SepDashBoard.vue'), // Ensure the extension is included
        },
        {
            path: "/bot",
            name: 'ChatBotPage',
            component: () => import('@/components/ChatBotPage.vue'), // Ensure the extension is included
        },
        {
            path: "/utilization",
            name: 'UtilizationDashboard',
            component: () => import('@/components/UtilizationDashboard.vue'), // Ensure the extension is included
        },
        {
            path: "/users",
            name: 'userList',
            component: () => import('@/views/userList.vue'), // Ensure the extension is included
        },
        {
            path: "/unauthorized",
            name: 'unAuthorized',
            component: () => import('@/views/unAuthorized.vue'), // Ensure the extension is included
        },
        {
            path: '/:catchAll(.*)',
            redirect: "/"
        },
    ],
})

export default router
